import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesome } from '../../components'

const Radio = ({
  idName,
  onChangeTrue,
  onChangeFalse,
  trueLabel,
  falseLabel,
  name
}) => (
  <>
    <div className='input__radio-options'>
      <div className='input__radio-option'>
        <div className='input__field'>
          <input
            className='input__radio-input'
            id={`${idName}-toggle-on`}
            name={`toggle${name}`}
            type='radio'
            onChange={onChangeTrue}
          />
          <FontAwesome className='input__icon' icon='check' type='far' />
        </div>
        <label className='input__radio-label' htmlFor={`${idName}-toggle-on`}>
          {trueLabel}
        </label>
      </div>
      <div className='input__radio-option'>
        <div className='input__field'>
          <input
            className='input__radio-input'
            id='toggle-off'
            name={`toggle${name}`}
            type='radio'
            onChange={onChangeFalse}
          />
          <FontAwesome className='input__icon' icon='check' type='far' />
        </div>
        <label className='input__radio-label' htmlFor={`${idName}-toggle-off`}>
          {falseLabel}
        </label>
      </div>
    </div>
  </>
)

Radio.defaultProps = {
  id: '',
  autocomplete: 'on',
  className: '',
  value: '',
  type: 'text',
  placeholder: 'Please select',
  isSearch: false,
  isSearching: false,
  isValid: true,
  name: '',
  onChangeTrue: () => {},
  onChangeFalse: () => {}
}

Radio.propTypes = {
  id: PropTypes.string,
  autocomplete: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  placeholder: PropTypes.string,
  isSearch: PropTypes.bool,
  isSearching: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  isValid: PropTypes.bool
}

export default Radio
